export default __webpack_public_path__ + "static/media/france.60195147.jpg";